import React, { useRef, useState, useEffect } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
  CFormCheck,
  CLoadingButton,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import {
  cilLockLocked,
  cilUser,
  cilBirthdayCake,
  cilInfo,
  cilCheck,
  cilAddressBook,
} from '@coreui/icons'
import { Helmet } from 'react-helmet'
import * as cusUtil from 'src/viewsCommon/CusUtil'
import * as cusUrlUtil from 'src/viewsCommon/CusUrlUtil'

import CusResultModal from 'src/viewsCommon/CusResultModal'
import DaumPostModal from 'src/components/DaumPostModal'
import CenterRuleDetailViewModal from 'src/viewsCus/centerRule/CenterRuleDetailViewModal'

const Register_pwan = (param) => {
  const [btnState, setBtnState] = useState(false)
  const [isResultOpen, setIsResultOpen] = useState(false)
  const [inputType, setInputType] = useState('회원가입')
  const [resultTitle, setResultTitle] = useState('')
  const [resultBody, setResultBody] = useState('')

  const openResultModal = () => {
    // 입력 팝업 open
    setIsResultOpen(true)
  }

  const closeResultModal = () => {
    if (resultTitle == '성공') {
      // 로그인화면으로 이동
      navigate('/login')
    }
    // 입력 팝업 close
    setIsResultOpen(false)
  }

  const [visible, setVisible] = useState(false)
  const [headerDesc, setHeaderDesc] = useState('화면설명')
  const [data, setData] = useState({})

  /** 우편번호 */
  const [isDaumPostOpen, setIsDaumPostOpen] = useState(false)

  const openDaumPostModal = () => {
    // 우편번호 팝업 open
    setIsDaumPostOpen(true)
  }

  const closeDaumPostModal = (param) => {
    console.log('closeDaumPostModal', param)
    // 우편번호 팝업 close
    setIsDaumPostOpen(false)

    if (param != null) {
      refs.addr.current.value = param
    }
  }

  // 전체 동의 체크박스
  const [selectAll, setSelectAll] = useState(false)
  const [checkboxes, setCheckboxes] = useState({
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
  })

  const handleSelectAllChange = (event) => {
    // console.log('handleSelectAllChange', event.target.checked)
    const checked = event.target.checked
    setSelectAll(checked)
    const updatedCheckboxes = { ...checkboxes }
    for (const key in updatedCheckboxes) {
      updatedCheckboxes[key] = checked
    }
    setCheckboxes(updatedCheckboxes)
  }

  const handleCheckboxChange = (event) => {
    // console.log('handleCheckboxChange', event.target)
    const { name, checked } = event.target
    setCheckboxes({
      ...checkboxes,
      [name]: checked,
    })

    // 현재 체크박스를 제외한 나머지 체크박스의 상태를 확인하여 전체 동의 상태 업데이트
    const otherCheckboxes = Object.keys(checkboxes).filter((key) => key !== name)
    const allOtherChecked = otherCheckboxes.every((key) => checkboxes[key])
    setSelectAll(allOtherChecked && checked)
  }

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)

  // 최초실행 (빈 배열을 전달하여 한 번만 실행)
  useEffect(() => {
    const urlParamUcuid = queryParams.get('ucuid')
    const urlParamMobileNo = queryParams.get('mno')
    // const urlParamName = queryParams.get('name')
    // const urlParamBirthday = queryParams.get('bd')
    if (urlParamUcuid) {
      refs.ucuid.current.value = urlParamUcuid
      refs.ucuidText.current.value = '본인인증 완료'
      refs.userid.current.value = urlParamMobileNo
      // refs.name.current.value = urlParamName
      // refs.birthday.current.value = urlParamBirthday
    } else {
      refs.ucuidText.current.value = '본인인증 미완료 *'
    }

    // 이벤트 리스너 함수
    const handleMessage = (event) => {
      // 출처 확인
      // console.log('event : ', event, event.origin, event.data)
      // console.log('Received message:', event.data)
      if (event.data.action === 'updateAndReload') {
        window.location.href = event.data.url
      } else {
        // console.warn('Unauthorized origin:', event.origin)
      }
    }

    // message 이벤트 리스너 추가
    window.addEventListener('message', handleMessage)

    // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  // 입력
  const navigate = useNavigate()

  const refs = {
    ucuid: useRef(null),
    ucuidText: useRef(null),
    userid: useRef(null),
    password: useRef(null),
    passwordRe: useRef(null),
    // name: useRef(null),
    // birthday: useRef(null),
    addr: useRef(null),
    addrDetail: useRef(null),
  }

  const saveData = () => {
    setBtnState(true)

    // console.log('refs.title: ', refs.title.current.value)
    setData((prevState) => ({
      ...prevState,
      ucuid: refs.ucuid.current.value,
      ucuidText: refs.ucuidText.current.value,
      userid: refs.userid.current.value,
      password: refs.password.current.value,
      passwordRe: refs.passwordRe.current.value,
      // name: refs.name.current.value,
      // birthday: refs.birthday.current.value,
      addr: refs.addr.current.value,
      addrDetail: refs.addrDetail.current.value,
    }))

    // 입력값 체크
    var saveDataCheckResult = ''
    if (refs.ucuid.current.value === '') {
      saveDataCheckResult = '본인인증이 완료되지 않았습니다.'
    } else if (refs.password.current.value === '') {
      saveDataCheckResult = '비밀번호를 입력해 주세요.'
    } else if (!/^\d{6}$/.test(refs.password.current.value)) {
      saveDataCheckResult = '형식에 맞게 비밀번호를 입력해 주세요. (숫자 6자리)'
    } else if (refs.passwordRe.current.value === '') {
      saveDataCheckResult = '비밀번호 확인을 입력해 주세요.'
    } else if (refs.password.current.value !== refs.passwordRe.current.value) {
      saveDataCheckResult = '입력한 비밀번호가 일치하지 않습니다.'
    } else if (checkboxes.checkbox1 === false || checkboxes.checkbox2 === false) {
      saveDataCheckResult = '필수약관에 동의해 주세요.'
    }
    if (saveDataCheckResult !== '') {
      setBtnState(false)
      setResultTitle('확인')
      setResultBody(saveDataCheckResult)
      openResultModal()
      return false
    }

    // 입력갑 보정
    // var modBirthday = refs.birthday.current.value
    // if (modBirthday.length === 8) {
    //  modBirthday = modBirthday.slice(2)
    // }

    const userDetailsRequest = {
      userCheckUid: refs.ucuid.current.value,
      // name: refs.name.current.value,
      // birthday: modBirthday,
      addr: refs.addr.current.value,
      addrDetail: refs.addrDetail.current.value,
    }

    const saveDataParam = {
      userid: refs.userid.current.value,
      password: refs.password.current.value,
      userDetailsRequest: userDetailsRequest,
    }
    console.log('saveDataParam: ', saveDataParam)

    cusUtil
      .axiosPostOrPut(
        '/cube_dev_local/api/guest/user/v02/user/withoutAuthNum',
        saveDataParam,
        param.uid,
      )
      .then((response) => {
        console.log(response)
        const responseData = response.data

        if (responseData.resultYne == 'Y') {
          setResultTitle('성공')
          setResultBody(inputType + '에 성공하였습니다.')
          openResultModal()
        } else {
          setResultTitle('에러')
          setResultBody('[' + responseData.resultYne + '] ' + responseData.resultMsg)
          openResultModal()
        }
        setBtnState(false)
      })
      .catch((error) => {
        console.error('register fail: ', error)
        if (error.response && error.response.data && error.response.data.resultYne) {
          const responseData = error.response.data
          if (responseData.resultCode) {
            let resultMsg = ''
            if (responseData.resultCode == '1001') {
              resultMsg = '이미 가입된 휴대폰번호(아이디) 입니다.'
            }
            setResultTitle('확인')
            setResultBody('[' + responseData.resultCode + '] ' + resultMsg)
          } else {
            setResultTitle('에러')
            setResultBody('[' + responseData.resultYne + '] ' + responseData.resultMsg)
          }
          openResultModal()
        } else {
          setResultTitle('예외사항 발생')
          setResultBody('[' + error.code + '] ' + error.message)
          openResultModal()
        }
        setBtnState(false)
      })
  }

  const handleCancel = () => {
    navigate('/login')
  }

  const handleCheckplus = () => {
    const closeButtonYn = encodeURIComponent('y')
    const closeButtonUrl = encodeURIComponent(
      window.location.protocol + '//' + window.location.host + '/login#/register',
    )
    const closeButtonFun = encodeURIComponent('')
    // console.log('closeButtonUrl :', window.location.protocol)
    // console.log('closeButtonUrl :', window.location.host)
    // console.log('closeButtonUrl :', closeButtonUrl)

    // const checkplus = `${process.env.REACT_APP_API_URL}/checkplus/mainUser?cid=&did=&cb=${closeButtonYn}&cbu=${closeButtonUrl}&cbf=${closeButtonFun}`
    const checkplus = `${cusUtil.getTargetUrl()}/checkplus/mainUser?cid=&did=&cb=${closeButtonYn}&cbu=${closeButtonUrl}&cbf=${closeButtonFun}`
    // window.location.href = checkplus
    window.open(checkplus, 'PopupWindow', 'width=500,height=550')
  }

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="{cusUrlUtil.getCidData()['REACT_APP_LOGO_IMAGE_TITLE']}"
        />
        <title>{cusUrlUtil.getCidData()['REACT_APP_LOGO_IMAGE_TITLE']}</title>
      </Helmet>

      <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
        <CContainer>
          <CRow className="justify-content-center">
            <CCol md={9} lg={7} xl={6}>
              <CCard className="mx-0">
                <CCardBody className="p-4">
                  <CForm>
                    <h2>Register</h2>
                    <p className="text-medium-emphasis">
                      본인인증후 기타 정보를 입력해 주세요. (* 필수정보)
                    </p>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilCheck} />
                      </CInputGroupText>
                      <CFormInput placeholder="" size="sm" ref={refs.ucuidText} disabled />
                      <CFormInput type="hidden" ref={refs.ucuid} />
                      <CButton color="primary" size="sm" onClick={() => handleCheckplus()}>
                        본인인증 하기
                      </CButton>
                    </CInputGroup>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput placeholder="휴대폰번호 *" ref={refs.userid} size="sm" disabled />
                    </CInputGroup>
                    {/* <CInputGroup className="mb-3">
                    <CInputGroupText>@</CInputGroupText>
                    <CFormInput placeholder="Email" autoComplete="email" />
                  </CInputGroup> */}
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        size="sm"
                        placeholder="비밀번호 * (숫자 6자리)"
                        ref={refs.password}
                      />
                    </CInputGroup>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        size="sm"
                        placeholder="비밀번호 확인 * (숫자 6자리)"
                        ref={refs.passwordRe}
                      />
                    </CInputGroup>
                    {/* <CInputGroup
                      className="mb-3"
                      style={{
                        display: 'none',
                      }}
                    >
                      <CInputGroupText>
                        <CIcon icon={cilInfo} />
                      </CInputGroupText>
                      <CFormInput placeholder="사용자이름" ref={refs.name} size="sm" disabled />
                    </CInputGroup>
                    <CInputGroup
                      className="mb-3"
                      style={{
                        display: 'none',
                      }}
                    >
                      <CInputGroupText>
                        <CIcon icon={cilBirthdayCake} />
                      </CInputGroupText>
                      <CFormInput placeholder="생년월일" ref={refs.birthday} size="sm" disabled />
                    </CInputGroup> */}

                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilAddressBook} />
                      </CInputGroupText>
                      <CFormInput placeholder="주소" ref={refs.addr} size="sm" disabled />
                      <CButton color="primary" size="sm" onClick={() => openDaumPostModal()}>
                        우편번호 찾기
                      </CButton>
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilAddressBook} />
                      </CInputGroupText>
                      <CFormInput placeholder="상세주소" ref={refs.addrDetail} size="sm" />
                    </CInputGroup>

                    <CInputGroup className="mb-4">
                      <div
                        style={{
                          width: '100%',
                        }}
                      >
                        <CRow>
                          <CCol
                            xs={8}
                            className="text-medium-emphasis small"
                            style={{
                              fontWeight: 'bold',
                            }}
                          >
                            <CFormCheck
                              id="ruleAll"
                              name="checkboxAll"
                              checked={selectAll}
                              onChange={handleSelectAllChange}
                              label="전체 동의"
                              className=" pt-1"
                            />
                          </CCol>
                          <CCol
                            xs={4}
                            className="text-right"
                            style={{
                              textAlign: 'right',
                            }}
                          ></CCol>
                        </CRow>
                      </div>
                      <div
                        style={{
                          width: '100%',
                        }}
                      >
                        <CRow>
                          <CCol xs={8} className="text-medium-emphasis small">
                            <CFormCheck
                              id="ruleService"
                              name="checkbox1"
                              checked={checkboxes.checkbox1}
                              onChange={handleCheckboxChange}
                              label="서비스 이용약관 동의 (필수)"
                              className=" pt-1"
                            />
                          </CCol>
                          <CCol
                            xs={4}
                            className="text-right"
                            style={{
                              textAlign: 'right',
                            }}
                          >
                            <CenterRuleDetailViewModal
                              ruleCd="01"
                              ruleText="약관보기"
                              isButton="y"
                            />
                          </CCol>
                        </CRow>
                      </div>
                      <div
                        style={{
                          width: '100%',
                        }}
                      >
                        <CRow>
                          <CCol xs={8} className="text-medium-emphasis small">
                            <CFormCheck
                              id="rulePrivacy"
                              name="checkbox2"
                              checked={checkboxes.checkbox2}
                              onChange={handleCheckboxChange}
                              label="개인정보수집 및 이용약관 동의 (필수)"
                              className=" pt-1"
                            />
                          </CCol>
                          <CCol
                            xs={4}
                            className="text-right"
                            style={{
                              textAlign: 'right',
                            }}
                          >
                            <CenterRuleDetailViewModal
                              ruleCd="02"
                              ruleText="약관보기"
                              isButton="y"
                            />
                          </CCol>
                        </CRow>
                      </div>
                      <div
                        style={{
                          width: '100%',
                        }}
                      >
                        <CRow>
                          <CCol xs={8} className="text-medium-emphasis small">
                            <CFormCheck
                              id="ruleAd"
                              name="checkbox3"
                              checked={checkboxes.checkbox3}
                              onChange={handleCheckboxChange}
                              label="마케팅 정보수신 동의 (선택)"
                              className=" pt-1"
                            />
                          </CCol>
                          <CCol
                            xs={4}
                            className="text-right"
                            style={{
                              textAlign: 'right',
                            }}
                          >
                            <CenterRuleDetailViewModal
                              ruleCd="04"
                              ruleText="약관보기"
                              isButton="y"
                            />
                          </CCol>
                        </CRow>
                      </div>
                    </CInputGroup>

                    <div
                      style={{
                        width: '100%',
                      }}
                    >
                      <CRow>
                        <CCol xs={6}>
                          <CButton
                            color="secondary"
                            style={{
                              width: '100%',
                            }}
                            onClick={() => handleCancel()}
                          >
                            취소
                          </CButton>
                        </CCol>
                        <CCol xs={6}>
                          <CLoadingButton
                            loading={btnState}
                            disabled={btnState}
                            color="success"
                            style={{
                              width: '100%',
                            }}
                            onClick={() => saveData()}
                          >
                            회원가입
                          </CLoadingButton>
                        </CCol>
                      </CRow>
                    </div>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </CContainer>
        <DaumPostModal isOpen={isDaumPostOpen} closeModal={closeDaumPostModal} />
        <CusResultModal
          isOpen={isResultOpen}
          closeModal={closeResultModal}
          resultTitle={resultTitle}
          resultBody={resultBody}
        />
      </div>
    </>
  )
}

export default Register_pwan
